import { get } from "../index";

export const getHealthReportbyId = (reportID) => {
  return get(`/model-health-report/by-report-id/${reportID}`);
};
